import { useApiPost } from 'src/api';
import { useMutation } from 'react-query';

export interface FeatureFlagReq {
  featureflags: string[];
  featurekey: string | undefined;
  rules: {
    [key: string]: string | undefined;
  };
}

interface ApiFeatureFlag {
  config?: string;
  value: string;
}

export interface FeatureFlagsResponse {
  [key: string]: ApiFeatureFlag;
}

export function useFeatureFlag(request: FeatureFlagReq) {
  const customHeaders = {
    'IM-Domain': 'pricing',
    'IM-SenderID': 'IMAEP',
  };
  const apiPost = useApiPost<FeatureFlagsResponse>({
    host: process.env.REACT_APP_FEATURE_FLAG_BASE,
  });
  return useMutation<FeatureFlagsResponse, Error, FeatureFlagReq>(() =>
    apiPost(
      `/feature-flags/treatments/config`,
      request,
      undefined,
      customHeaders
    )
  );
}
